import { HsaContentStep } from "@redotech/redo-flows-common/advanced-flow-db-parser";
import { useTranslation } from "@redotech/redo-i18n";
import FileIcon from "@redotech/redo-icons/file-02.svg";
import { RedoBadge } from "@redotech/redo-web/arbiter-components/badge/redo-badge";
import { RedoFeaturedIcon } from "@redotech/redo-web/arbiter-components/featured-icon/redo-featured-icon";
import { Flex } from "@redotech/redo-web/flex";
import { Text } from "@redotech/redo-web/text";
import { Handle, Position } from "@xyflow/react";
import { memo } from "react";
import { PartialWithRequiredType } from "../steps";
import { BaseNode } from "./base-node";
import * as NodeCSS from "./node.module.css";

export interface HsaContentNodeData {
  step: PartialWithRequiredType<HsaContentStep>;
  deleteElements: (id: string) => void;
  readonly: boolean;
}

export const HsaContentNode = memo(function HsaContentNode({
  id,
  data,
  selected,
}: {
  id: string;
  data: HsaContentNodeData;
  selected?: boolean | undefined;
}) {
  const { t } = useTranslation();

  return (
    <BaseNode
      containerClassName={NodeCSS.checkoutNode}
      icon={<RedoFeaturedIcon color="gray" Icon={FileIcon} size="sm" />}
      onDelete={data.readonly ? undefined : () => data.deleteElements(id)}
      selected={selected}
      step={data.step}
      title={t("Content screen")}
    >
      <Handle id="top" position={Position.Top} type="target" />
      <Flex className={NodeCSS.fullWidth} dir="column" gap="xs">
        <Text fontSize="xxs" textColor="secondary">
          {t("Heading")}
        </Text>
        {data.step.heading ? (
          <Text className={NodeCSS.clampedValueText}>{data.step.heading}</Text>
        ) : (
          <Text className={NodeCSS.placeholderText}>{t("No heading")}</Text>
        )}
        {data.step.recordsConsent && (
          <Flex w="full">
            <RedoBadge color="success" size="xs" text={t("Records consent")} />
          </Flex>
        )}
      </Flex>
      <Handle id="bottom" position={Position.Bottom} type="source" />
    </BaseNode>
  );
});
